module.exports = {"expand":"Rozbaliť","hide":"Zbaliť","up":"Hore","down":"Nadol","navigationTitle":"Navigácia"}